// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  border-bottom: 1px solid grey;
  min-height: 70px;
  padding: 0 30px;
}

.header[theme=light] {
  border-bottom: 1px solid #bdbdbd;
  background: #fff;
}

.nav-item-4 .theme-btn {
  background-color: #f3f4f6;
  color: #26282b;
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 12.5px;
}
.nav-item-4 .theme-btn:hover, .nav-item-4 .theme-btn:focus {
  background-color: #e6e7ea;
  color: #26282b;
  border-color: transparent;
}

.header-profile-icon img {
  width: 30px;
  border-radius: 50%;
  aspect-ratio: 1/1;
  offset: 3px;
}

.main_logo {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 14px;
}

.brand-divider {
  width: 1px;
  height: 26px;
  background: #e6e7ea;
}

.nav-arrows {
  display: flex;
  align-items: center;
  column-gap: 2px;
}

.nav-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #8a8f98;
  cursor: pointer;
}
.nav-arrow-btn:hover {
  color: #525761;
  background: #f3f4f6;
}

.notif-dot {
  position: absolute;
  top: -2px;
  right: -6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e0554a;
  border: 1.5px solid #fff;
}

.header-logo {
  align-items: center;
  column-gap: 14px;
}
.header-logo img {
  height: 44px;
  transform: skewX(-8deg);
  display: block;
}

.header-logo .company-name {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  font-weight: 800;
  font-size: 15px;
  color: #333333;
}

li {
  display: flex;
  align-items: center;
}

.navbar-nav {
  display: flex;
  align-items: center;
  width: auto !important;
  column-gap: 28px;
}

.nav-item-1 {
  align-items: center;
  width: auto;
  column-gap: 28px;
}

.nav-item-2 {
  width: auto;
}

.nav-item-3 {
  width: auto;
  column-gap: 8px;
}

.nav-item-4 {
  width: auto;
  display: flex;
}

@media only screen and (max-width: 767px) {
  .main_logo {
    width: 90%;
    justify-content: start;
    padding-left: 20px;
  }
  .navbar {
    display: flex;
    justify-content: center;
  }
  .nav-item-1 {
    width: 40%;
  }
  .nav-item-2 {
    width: 25%;
  }
  .nav-item-3 {
    width: 25%;
  }
  .nav-item-4 {
    width: 10%;
    display: flex;
    justify-content: end;
  }
}
@media only screen and (max-width: 986px) {
  .main_logo {
    width: 40%;
    display: flex;
    justify-content: center;
  }
  .navbar {
    display: flex;
    justify-content: center;
  }
  .nav-item-1 {
    width: 35%;
  }
  .nav-item-2 {
    width: 15%;
  }
  .nav-item-3 {
    width: 30%;
  }
  .nav-item-4 {
    width: 20%;
    display: flex;
    justify-content: end;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/common/Header/Header.scss","webpack://./src/_App.variables.scss"],"names":[],"mappings":"AA0EA;EACC,6BAAA;EACA,gBAAA;EAGA,eAAA;AA3ED;;AA8EA;EACC,gCAAA;EACA,gBAAA;AA3ED;;AA8EA;EACC,yBCtEgB;EDuEhB,cC5EgB;ED6EhB,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AA3ED;AA6EC;EAEC,yBChFe;EDiFf,cCrFe;EDsFf,yBAAA;AA5EF;;AAgFA;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EAEA,WAAA;AA9ED;;AA0FA;EAKC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AA3FD;;AA8FA;EACC,UAAA;EACA,YAAA;EACA,mBCtHgB;AD2BjB;;AA8FA;EACC,aAAA;EACA,mBAAA;EACA,eAAA;AA3FD;;AA8FA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cC1IgB;ED2IhB,eAAA;AA3FD;AA6FC;EACC,cC/Ie;EDgJf,mBC5Ie;ADiDjB;;AA+FA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AA5FD;;AA+FA;EACC,mBAAA;EACA,gBAAA;AA5FD;AA8FC;EACC,YAAA;EACA,uBAAA;EACA,cAAA;AA5FF;;AAmGA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhGD;;AAmGA;EACC,aAAA;EACA,mBAAA;AAhGD;;AAqGA;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAlGD;;AAqGA;EACC,mBAAA;EACA,WAAA;EACA,gBAAA;AAlGD;;AAqGA;EACC,WAAA;AAlGD;;AAqGA;EACC,WAAA;EACA,eAAA;AAlGD;;AAqGA;EACC,WAAA;EACA,aAAA;AAlGD;;AAqGA;EACC;IACC,UAAA;IACA,sBAAA;IACA,kBAAA;EAlGA;EAqGD;IACC,aAAA;IACA,uBAAA;EAnGA;EAsGD;IACC,UAAA;EApGA;EAuGD;IACC,UAAA;EArGA;EAwGD;IACC,UAAA;EAtGA;EAyGD;IACC,UAAA;IACA,aAAA;IACA,oBAAA;EAvGA;AACF;AA0GA;EACC;IACC,UAAA;IACA,aAAA;IACA,uBAAA;EAxGA;EA2GD;IACC,aAAA;IACA,uBAAA;EAzGA;EA4GD;IACC,UAAA;EA1GA;EA6GD;IACC,UAAA;EA3GA;EA8GD;IACC,UAAA;EA5GA;EA+GD;IACC,UAAA;IACA,aAAA;IACA,oBAAA;EA7GA;AACF","sourcesContent":["// .header {\n//     border-bottom: 1px solid #fff;\n//     height: 64px;\n//     position: fixed;\n//     top: 0;\n//     left: 0;\n//     right: 0;\n//     width: 100vw;\n//     z-index: 1;\n//     background-color: transparent;\n//     display: flex;\n//     align-items: center;\n//     justify-content: space-between;\n\n//     .additional_links {\n//         width: calc(100% - 32rem);\n//         padding-right: 50px;\n\n//         .additional_links_block {\n//             display: flex;\n//             align-items: center;\n//             justify-content: space-between;\n\n//             .block {\n//                 display: flex;\n//                 align-items: center;\n//             }\n\n//             .link_block {\n//                 column-gap: 10px;\n//                 display: flex;\n//                 align-items: center;\n//                 font-size: 13px;\n//                 color: #333;\n\n//                 .fa {\n//                     font-weight: 500;\n//                     font-size: 15px;\n//                 }\n\n//                 .icon_box {\n//                     display: flex;\n//                     align-items: center;\n//                     // margin-right: 10px;\n\n//                     &.notification {\n//                         // margin-right: 37px;\n//                     }\n\n//                     svg {\n//                         height: 16px;\n//                         width: 18px;\n//                     }\n//                 }\n\n//                 .svg_wrapper_profile_icon {\n//                     width: 30px;\n//                     height: 30px;\n//                     // margin-right: 15px;\n\n//                     img {\n//                         height: 100%;\n//                         width: 100%;\n//                         border-radius: 50%;\n//                         border: 1px solid grey;\n//                     }\n//                 }\n//             }\n//         }\n//     }\n// }\n\n@import '../../../_App.variables.scss';\n\n.navbar {\n\tborder-bottom: 1px solid grey;\n\tmin-height: 70px;\n\t// Matches .dashboard_container's own horizontal padding (Dashboard.scss)\n\t// so the nav lines up with SideBar / .dashboard_rightcontainer below it.\n\tpadding: 0 30px;\n}\n\n.header[theme='light'] {\n\tborder-bottom: 1px solid #bdbdbd;\n\tbackground: #fff;\n}\n\n.nav-item-4 .theme-btn {\n\tbackground-color: $color-gray-100;\n\tcolor: $color-gray-900;\n\tborder: none;\n\tborder-radius: 8px;\n\tpadding: 9px 16px;\n\tfont-size: 12.5px;\n\n\t&:hover,\n\t&:focus {\n\t\tbackground-color: $color-gray-200;\n\t\tcolor: $color-gray-900;\n\t\tborder-color: transparent;\n\t}\n}\n\n.header-profile-icon img {\n\twidth: 30px;\n\tborder-radius: 50%;\n\taspect-ratio: 1/1;\n\n\toffset: 3px;\n\t// border: 2px solid grey;\n\t// transition: border-color 0.3s ease;\n\n\t// &[state='active'] {\n\t// \tborder-color: #d4fb41;\n\t// }\n\t// &[state='inactive'] {\n\t// \tborder-color: rgb(141, 49, 49);\n\t// }\n}\n\n.main_logo {\n\t// 30% still matches .sidebar_container's width (SideBar.scss), so\n\t// the nav row that follows starts exactly where the sidebar ends\n\t// and the main content column begins — the logo itself just sits\n\t// left-aligned in that column now, instead of centered in it.\n\twidth: 30%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tcolumn-gap: 14px;\n}\n\n.brand-divider {\n\twidth: 1px;\n\theight: 26px;\n\tbackground: $color-gray-200;\n}\n\n.nav-arrows {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 2px;\n}\n\n.nav-arrow-btn {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 22px;\n\theight: 22px;\n\tbackground: transparent;\n\tborder: none;\n\tborder-radius: 5px;\n\tcolor: $color-gray-500;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: $color-gray-700;\n\t\tbackground: $color-gray-100;\n\t}\n}\n\n.notif-dot {\n\tposition: absolute;\n\ttop: -2px;\n\tright: -6px;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50%;\n\tbackground: #e0554a;\n\tborder: 1.5px solid #fff;\n}\n\n.header-logo {\n\talign-items: center;\n\tcolumn-gap: 14px;\n\n\timg {\n\t\theight: 44px;\n\t\ttransform: skewX(-8deg);\n\t\tdisplay: block;\n\t}\n}\n\n// Scoped under .header-logo (rather than a bare .company-name rule) so\n// this reliably overrides the older global .company-name rule in\n// App.scss (grey, 20px, single line) regardless of stylesheet order.\n.header-logo .company-name {\n\tdisplay: flex;\n\tflex-direction: column;\n\tline-height: 1.1;\n\tfont-weight: 800;\n\tfont-size: 15px;\n\tcolor: #333333;\n}\n\nli {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n// The nav row is one evenly-spaced flex line that hugs the logo,\n// not four fixed-percentage columns stretched across the bar.\n.navbar-nav {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: auto !important;\n\tcolumn-gap: 28px;\n}\n\n.nav-item-1 {\n\talign-items: center;\n\twidth: auto;\n\tcolumn-gap: 28px;\n}\n\n.nav-item-2 {\n\twidth: auto;\n}\n\n.nav-item-3 {\n\twidth: auto;\n\tcolumn-gap: 8px;\n}\n\n.nav-item-4 {\n\twidth: auto;\n\tdisplay: flex;\n}\n\n@media only screen and (max-width: 767px) {\n\t.main_logo {\n\t\twidth: 90%;\n\t\tjustify-content: start;\n\t\tpadding-left: 20px;\n\t}\n\n\t.navbar {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.nav-item-1 {\n\t\twidth: 40%;\n\t}\n\n\t.nav-item-2 {\n\t\twidth: 25%;\n\t}\n\n\t.nav-item-3 {\n\t\twidth: 25%;\n\t}\n\n\t.nav-item-4 {\n\t\twidth: 10%;\n\t\tdisplay: flex;\n\t\tjustify-content: end;\n\t}\n}\n\n@media only screen and (max-width: 986px) {\n\t.main_logo {\n\t\twidth: 40%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.navbar {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.nav-item-1 {\n\t\twidth: 35%;\n\t}\n\n\t.nav-item-2 {\n\t\twidth: 15%;\n\t}\n\n\t.nav-item-3 {\n\t\twidth: 30%;\n\t}\n\n\t.nav-item-4 {\n\t\twidth: 20%;\n\t\tdisplay: flex;\n\t\tjustify-content: end;\n\t}\n}\n","// Variables\n$color-primary: #333333;\n$color-light: #ffffff;\n\n$text-primary: #ffffff;\n$text-dark: #333333;\n\n$color-icon-main: #404040;\n$color-icon-secondary: #bfbfbf;\n\n// Seller Central visual refresh\n$color-accent: #d4fb41;\n$color-accent-dark: #4c6b0d; // readable text/icon color for the chartreuse accent on white\n$color-gray-900: #26282b;\n$color-gray-700: #525761;\n$color-gray-500: #8a8f98;\n$color-gray-300: #d8dade;\n$color-gray-200: #e6e7ea;\n$color-gray-100: #f3f4f6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
